module.exports = "data:application/x-font-ttf;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICI2YmNkZWM0ZDdlNTAyOTM4MjBjYmQ1NjY5YmUzY2ZmNS50dGYiOw=="


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/icon-font/iconFont.ttf
// module id = 1481
// module chunks = 0